"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNotFound = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _RowOneCol = _interopRequireDefault(require("../../LayoutContainers/RowOneCol"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledNotFound = (0, _styledComponents.default)(_RowOneCol.default).withConfig({
  displayName: "Oopsstyles__StyledNotFound",
  componentId: "yhrgtm-0"
})(["text-align:center;.c-oops-alert-icon{font-size:6rem;margin-top:2rem;}.c-oops-contact-text{text-align:left;}"]);
exports.StyledNotFound = StyledNotFound;